import './index.scss';
import { array, bool, func, oneOfType, string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { PortalWithState } from 'react-portal';
import GeniusSearch from '~/components/genius_search';
const MultiSelectInput = ({ hasSearchFilter, name, onChange, options, renderSubOptions, selectedOptions, }) => {
    MultiSelectInput.propTypes = {
        hasSearchFilter: bool,
        name: string.isRequired,
        onChange: func.isRequired,
        options: array,
        renderSubOptions: bool,
        selectedOptions: oneOfType([array, string]),
    };
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [searchText, setSearchText] = useState('');
    const [dimensions, setDimensions] = useState(null);
    const multiSelectRef = useRef();
    const portalRef = useRef();
    const updateDimensions = () => {
        if (multiSelectRef.current) {
            const dimensions = multiSelectRef.current.getBoundingClientRect();
            setDimensions({
                left: dimensions.left,
                top: dimensions.top + dimensions.height,
                width: dimensions.width,
                maxHeight: (dimensions.top + 300 > window.innerHeight)
                    ? (window.innerHeight - dimensions.top - dimensions.height)
                    : 300,
            });
        }
    };
    const handleScroll = (e) => {
        if (portalRef.current && !e.target.classList.contains('multi-select-options')) {
            portalRef.current.closePortal();
        }
    };
    const handleClickOutside = (e) => {
        if (portalRef.current && !e.target.closest('.multi-select-options')) {
            portalRef.current.closePortal();
        }
    };
    useEffect(() => {
        document.addEventListener('scroll', handleScroll, true);
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('scroll', handleScroll, true);
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    const handleCheckboxClick = option => {
        const updatedSelectedOptions = selectedOptions.includes(option)
            ? selectedOptions.filter(selectedOption => selectedOption !== option)
            : [...selectedOptions, option];
        onChange(name, updatedSelectedOptions);
    };
    const buildOptionsList = (options, nestLevel = 0) => {
        const paddingLeft = `${nestLevel * 15}px`;
        if (options === null || options === void 0 ? void 0 : options.length) {
            return options.map((option, index) => {
                if (option.subOptions && renderSubOptions) {
                    return (React.createElement(React.Fragment, { key: `${name}-option-${index}` },
                        React.createElement("label", { htmlFor: option.optionName, title: option.optionName, style: { paddingLeft } },
                            React.createElement("input", { className: 'multi-select-checkbox', type: 'checkbox', disabled: true }),
                            option.optionName),
                        buildOptionsList(option.subOptions, nestLevel + 1)));
                }
                return (React.createElement("label", { htmlFor: option.optionName, key: `${name}-${option.optionName}`, title: option.optionName, style: { paddingLeft }, onClick: () => handleCheckboxClick(option.optionName) },
                    React.createElement("input", { checked: selectedOptions.includes(option.optionName), className: 'multi-select-checkbox', type: 'checkbox', readOnly: true }),
                    option.optionName));
            });
        }
        else {
            return (React.createElement("div", { style: { margin: '5px' } }, Array.isArray(options) ? 'No Options' : 'Loading...'));
        }
    };
    const handleSearch = value => {
        const allOptions = renderSubOptions ? options.flatMap(option => option.subOptions) : options;
        setFilteredOptions(allOptions === null || allOptions === void 0 ? void 0 : allOptions.filter(x => x.optionName.toLowerCase().includes(value.toLowerCase())));
    };
    const handleOpenPortal = (e) => {
        updateDimensions();
        if (portalRef.current) {
            portalRef.current.openPortal(e);
        }
    };
    selectedOptions = selectedOptions || [];
    options = hasSearchFilter && searchText !== '' ? filteredOptions : options;
    const title = selectedOptions.length && Array.isArray(selectedOptions)
        ? selectedOptions.join(', ')
        : name;
    return (React.createElement(PortalWithState, { closeOnEsc: true, ref: portalRef }, ({ portal }) => (React.createElement("div", { className: 'multi-select-container' },
        React.createElement("div", { className: 'multi-select-dropdown', ref: multiSelectRef },
            React.createElement("div", { className: 'select-box', onClick: (e) => handleOpenPortal(e), title: title },
                React.createElement("select", null,
                    React.createElement("option", null, title)),
                React.createElement("div", { className: 'over-select' })),
            dimensions && portal(React.createElement("div", { className: 'multi-select-options', style: {
                    top: dimensions.top,
                    left: dimensions.left,
                    width: `${dimensions.width}px`,
                    maxHeight: `${dimensions.maxHeight}px`,
                } },
                hasSearchFilter && (options === null || options === void 0 ? void 0 : options.length) > 0 &&
                    React.createElement(GeniusSearch, { customClassName: 'dropdown-search-bar', handleSearch: handleSearch, id: `${name}-dropdown-search-bar`, placeholder: 'filter options', searchText: searchText, setSearchText: setSearchText }),
                buildOptionsList(options)))),
        React.createElement("span", { className: 'clear-multi-select-btn', onClick: () => onChange(name, []) },
            React.createElement("span", { className: 'fa-lg fal fa-times-circle' }))))));
};
export default MultiSelectInput;
